import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"width":"600px"}
}
const _hoisted_2 = {
  key: 0,
  class: "has-text-danger pb-5"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, "Documents of this registration have already been archived and are not accessible from the application.", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createTextVNode("If any file needs to be restored, please open a ticket via Service Desk "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" and provide the registration number and name of the file.")
], -1)
const _hoisted_5 = { class: "doc-modal-button-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_read_only_grid = _resolveComponent("read-only-grid")
  const _component_modal_card = _resolveComponent("modal-card")

  return (_openBlock(), _createBlock(_component_modal_card, { active: _ctx.isVisible }, {
    title: _withCtx(() => [
      _createTextVNode("Supporting Documents of " + _toDisplayString(_ctx.registration?.registrationNumber), 1)
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (_ctx.areFilesArchived)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_read_only_grid, {
          gridColumns: _ctx.columns,
          gridItems: _ctx.docs,
          isLoading: _ctx.isLoading,
          pageItemsOptions: [10, 20, 50],
          onCellClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCellClicked($event)))
        }, null, 8, ["gridColumns", "gridItems", "isLoading"])
      ])
    ]),
    foot: _withCtx(() => [
      _createVNode("div", _hoisted_5, [
        _createVNode("button", {
          type: "button",
          class: "button is-success",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCloseClick && _ctx.onCloseClick(...args)))
        }, " Close ")
      ])
    ]),
    _: 1
  }, 8, ["active"]))
}